import React from 'react';
import { CTAButtonWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import Image from '../../../components/loggedout/common/Image';
import * as S from './style';
import { PlayButton, PlayButtonContainer } from '../../../../../landing-pages/js/common/styled-components/styled-components';
import { CTAPrimaryButton } from '../../../components/loggedout/shared-styles/CTAPrimaryButton';

import VideoModal from '../../../../../landing-pages/js/screens/main-section-video/videoModal';
import OddbodsBooksGif from '~images/oddbods/get_all_oddbods_books.gif';
import { OddbodsVideo } from '../../../constant-data/urls';
import { isMobileDevice } from '../../../utils/web-helper';
// import { PARENT_SIGNUP_PATH } from '../../../routes/route-paths';

const ScreenTime = ({btnClickEvent, ctaText, urlToRedirect }) => {

  const [showVideoOverlay, setShowVideoOverlay] = React.useState(false);

  const trackPromoPageEvents = (category, properties, sendGA) =>{
    if(category)
      trackAnalyticsEvent(category, properties, sendGA)
  }

  const onPlayClickHandler = () => {
    console.info('starting video play');
    trackPromoPageEvents("Oddbods Page Interacted",{"clicked_on" : "video_started"}, true);
    setShowVideoOverlay(true);
  }

  const videoOverlayCloseHandler = () => {
    console.log('closing video.');
    setShowVideoOverlay(false);
  }
  
  let headingText = "Meaningful screen time with Oddbods books";
  // let ctaText = 'Sign up for free'; 
  const content_text1 = isMobileDevice() ? 'Build a daily reading routine with the Oddbods your kids already love.' : 'From helping your child read their first book to building a daily reading routine - do it with the Oddbods they already love!';
  const content_text2 = 'These adventurous tales from Oddsville keep children engaged and help them develop social-emotional skills as well.';

  return (
    <S.ContainerWrapper noBackground={true}>
      <S.Wrapper>
        <S.FeaturesWrapper>
          <S.HeadingText>{headingText}</S.HeadingText>
          <S.ContentWrapper>
            <S.Content>
              {content_text1}
            </S.Content>
            <S.Content>
              {content_text2}
            </S.Content>
          </S.ContentWrapper>
        </S.FeaturesWrapper>
        <S.ImageWrapper>
          <Image src={OddbodsBooksGif} ></Image>
          <PlayButtonContainer onClick={() => onPlayClickHandler()}>
            <PlayButton/>
            <p>KNOW MORE</p>
          </PlayButtonContainer>
          {showVideoOverlay  &&
            <VideoModal videoSrc={OddbodsVideo} videoOverlayCloseHandler={videoOverlayCloseHandler} trackPromoPageEvents={trackPromoPageEvents} />
          }
        </S.ImageWrapper>
      </S.Wrapper>

      <S.BtnWrapper>
        <CTAButtonWrapper>
          <CTAPrimaryButton darkBlue={true}>
            <a href={urlToRedirect} onClick={btnClickEvent}>
              {ctaText}
            </a>
          </CTAPrimaryButton>
        </CTAButtonWrapper>
      </S.BtnWrapper>

    </S.ContainerWrapper>
  )
}

export default ScreenTime;